module.exports = __webpack_public_path__ + "static/media/home.f66e8b3f.svg";